import { Pedido, PedidoSituacao } from './pedido';

// A jornada que o cliente ve, montada sobre a situacao que o backend ja devolve em
// GET integracao/pedido/{id}. Nada aqui e inventado: sao os mesmos valores do enum.
export type PedidoEtapa = {
  situacao: PedidoSituacao;
  nome: string;
  concluida: boolean;
  atual: boolean;
};

const NOMES: { [situacao: number]: string } = {
  [PedidoSituacao.Pendente]: 'Aguardando aprovação',
  [PedidoSituacao.Autorizado]: 'Pedido aceito',
  [PedidoSituacao.Expedido]: 'Saiu para entrega',
  [PedidoSituacao.Entregue]: 'Entregue',
  [PedidoSituacao.Encerrado]: 'Concluído',
  [PedidoSituacao.Cancelado]: 'Cancelado',
  [PedidoSituacao.Rejeitado]: 'Recusado pelo estabelecimento',
};

// Retirada e mesa nao tem entregador: "saiu para entrega" nunca acontece nesses casos,
// e "entregue" vira "pronto". Mostrar etapa que nao vai acontecer so confunde.
const NOMES_SEM_ENTREGA: { [situacao: number]: string } = {
  [PedidoSituacao.Expedido]: 'Pronto para retirada',
  [PedidoSituacao.Entregue]: 'Retirado',
};

export function pedidoSituacaoNome(situacao: PedidoSituacao, entrega: boolean = true): string {
  if (!entrega && NOMES_SEM_ENTREGA[situacao]) {
    return NOMES_SEM_ENTREGA[situacao];
  }
  return NOMES[situacao] || '';
}

export function pedidoSituacaoEncerrada(situacao: PedidoSituacao): boolean {
  return (
    situacao === PedidoSituacao.Cancelado ||
    situacao === PedidoSituacao.Rejeitado ||
    situacao === PedidoSituacao.Encerrado ||
    situacao === PedidoSituacao.Entregue
  );
}

export function pedidoSituacaoNegada(situacao: PedidoSituacao): boolean {
  return situacao === PedidoSituacao.Cancelado || situacao === PedidoSituacao.Rejeitado;
}

// O porque da recusa, no texto que o estabelecimento viu (ex.: 'O atendimento "Mesa 5"
// esta bloqueado', a mesma frase do PDV). Vale a ultima ocorrencia de cancelamento ou
// recusa; a ocorrencia guarda o numero da situacao no `motivo`.
export function pedidoNegadaMotivo(pedido: Pedido): string {
  if (!pedido || !pedidoSituacaoNegada(pedido.situacao)) {
    return '';
  }
  const ocorrencia = (pedido.pedidoOcorrencias || [])
    .filter(item => pedidoSituacaoNegada(item?.situacao || item?.motivo) && item?.observacoes?.trim())
    .pop();
  return ocorrencia ? ocorrencia.observacoes.trim() : '';
}

// Cancelado e Rejeitado nao sao um passo adiante na linha do tempo: eles a interrompem.
// Por isso a jornada deles e curta e nao mostra o caminho que nao vai acontecer.
export function pedidoJornada(situacao: PedidoSituacao, entrega: boolean = true): PedidoEtapa[] {
  if (pedidoSituacaoNegada(situacao)) {
    return [
      etapa(PedidoSituacao.Pendente, entrega, true, false),
      etapa(situacao, entrega, false, true),
    ];
  }

  const sequencia = [
    PedidoSituacao.Pendente,
    PedidoSituacao.Autorizado,
    PedidoSituacao.Expedido,
    PedidoSituacao.Entregue,
  ];

  return sequencia.map(passo =>
    etapa(passo, entrega, passo < situacao, passo === situacao),
  );
}

function etapa(
  situacao: PedidoSituacao,
  entrega: boolean,
  concluida: boolean,
  atual: boolean,
): PedidoEtapa {
  return { situacao, nome: pedidoSituacaoNome(situacao, entrega), concluida, atual };
}
